import React from 'react';
import Chip from '@mui/material/Chip';
import Box from '@mui/material/Box';
import { getInscricaoStatusDisplay } from '../../utils/inscricaoStatusDisplay';

export interface InscricaoStatusChipProps {
  status: string;
  pagamentoStatus?: string | null;
  isento?: boolean | null;
}

const COLORS: Record<string, { label: string; color: string; bg: string }> = {
  PEDIDO_REEMBOLSO: { label: 'Pedido reembolso', color: '#6f42c1', bg: 'rgba(111,66,193,0.2)' },
};

// This component is shared: InscricaoDetailPage's payment-status row passes a raw
// StatusPagamento value as `status`, not a StatusInscricao. This entry preserves that
// caller's green "Pago" rendering.
const PAGAMENTO_ONLY_COLORS: Record<string, { label: string; color: string; bg: string }> = {
  PAGO: { label: 'Pago', color: '#28a745', bg: 'rgba(40,167,69,0.2)' },
};

const InscricaoStatusChip: React.FC<InscricaoStatusChipProps> = ({ status, pagamentoStatus, isento }) => {
  const cfg =
    status === 'PEDIDO_REEMBOLSO'
      ? COLORS.PEDIDO_REEMBOLSO
      : PAGAMENTO_ONLY_COLORS[status] ?? getInscricaoStatusDisplay({ status, pagamentoStatus, isento });
  return (
    <Chip
      label={cfg.label}
      className='ps-2'
      sx={{
        backgroundColor: cfg.bg,
        color: cfg.color,
        fontWeight: 500,
        '& .MuiChip-icon': { marginLeft: 0, marginRight: 0.5 },
      }}
      icon={
        <Box
          aria-hidden="true"
          sx={{ width: 8, height: 8, borderRadius: '50%', backgroundColor: cfg.color }}
        />
      }
      size="small"
    />
  );
};

export default InscricaoStatusChip;
